import { ExternalUrlsValidation } from 'app/area/external-url-groups/form/types-store';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { complexValidationFromServer, ServerValidationErrors } from 'app/infrastructure/data/validation';

export const mapExternalUrlsValidation = (
  serverErrors: ServerValidationErrors
): ExternalUrlsValidation => {

  const groupedValidation = Object.keys(serverErrors || {}).reduce(
    (result, key) => {
      const validationMessages = serverErrors[key];

      if (Array.isArray(validationMessages)) {

        return validationMessages.reduce(
          (messages, message) => {

            if (typeof message === 'object' && isDefinedIncludingZero(message.parameters?.code)) {

              const currentServerErrors = messages[message.parameters.code] || {};

              return {
                ...messages,
                [message.parameters.code]: {
                  ...currentServerErrors,
                  [key]: [
                    ...(currentServerErrors[key] || []),
                    message
                  ]
                }
              };
            }

            return messages;
          }, result
        );
      }

      return result;
    }, {} as { [externalUrlId: number]: ServerValidationErrors }
  );

  return Object.keys(groupedValidation).reduce(
    (result, key) => {

      const validation = groupedValidation[key];

      return {
        ...result,
        [key]: complexValidationFromServer(validation)
      };
    }, {} as ExternalUrlsValidation
  );
};
